__turbopack_context__.v({
  "extraFiles": "DemoContentLoading-module__nEZJJG__extraFiles",
});
